angular
	.module 'App.Module.TrackingCategory', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'tracking_category',
				url: '/tracking_categories',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@tracking_category':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'TrackingCategoryRepository'
						title: 'general.tracking_categories'
					restrict: 'Shared.Setting.TrackingCategories.Enabled'

			.state 'tracking_category.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					trackingCategory: (TrackingCategoryRepository, $stateParams) ->
						return TrackingCategoryRepository.getEntity $stateParams.id

			.state 'tracking_category.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'TrackingCategoryController'
						controllerAs: 'vm'
						templateUrl: '@app/tracking-category/tracking-category.view.html'
